/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../../base';
// @ts-ignore
import type { AdminGetFeedPostsAlbaoneResponse } from '../../src/model';
// @ts-ignore
import type { AdminGetFeedPostsAlbaoneServerErrorDto } from '../../src/model';
// @ts-ignore
import type { AdminGetFeedPostsBadGatewayDto } from '../../src/model';
// @ts-ignore
import type { AdminGetFeedPostsBadRequestDto } from '../../src/model';
// @ts-ignore
import type { AdminGetFeedPostsInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { AdminGetFeedPostsOkDto } from '../../src/model';
// @ts-ignore
import type { AdminGetFeedsAlbaoneResponse } from '../../src/model';
// @ts-ignore
import type { AdminGetFeedsAlbaoneServerErrorDto } from '../../src/model';
// @ts-ignore
import type { AdminGetFeedsBadGatewayDto } from '../../src/model';
// @ts-ignore
import type { AdminGetFeedsBadRequestDto } from '../../src/model';
// @ts-ignore
import type { AdminGetFeedsInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { AdminGetFeedsOkDto } from '../../src/model';
// @ts-ignore
import type { AdminMatchFeedAndUserResponse } from '../../src/model';
// @ts-ignore
import type { AdminResolveFeedErrorAlbaoneResponse } from '../../src/model';
// @ts-ignore
import type { JwtAdminAccessGuardUnauthorizedDto } from '../../src/model';
// @ts-ignore
import type { MatchFeedAndUserBadGatewayDto } from '../../src/model';
// @ts-ignore
import type { MatchFeedAndUserBadRequestDto } from '../../src/model';
// @ts-ignore
import type { MatchFeedAndUserCreatedDto } from '../../src/model';
// @ts-ignore
import type { MatchFeedAndUserFeedConflictDto } from '../../src/model';
// @ts-ignore
import type { MatchFeedAndUserInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { MatchFeedAndUserReqBodyDto } from '../../src/model';
// @ts-ignore
import type { MatchFeedAndUserSnsIdConflictDto } from '../../src/model';
// @ts-ignore
import type { ResolveFeedAndUserRequestDto } from '../../src/model';
// @ts-ignore
import type { ResolveFeedErrorCreatedDto } from '../../src/model';
/**
 * AdminAlbaoneApi - axios parameter creator
 * @export
 */
export const AdminAlbaoneApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 특정 알바원 피드의 게시물 목록 조회
         * @param {string} feedUuid 알바원 피드 uuid
         * @param {string} [snsAccountUuid] SNS 계정 uuid
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        adminAlbaoneControllerGetFeedPosts: async (feedUuid: string, snsAccountUuid?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'feedUuid' is not null or undefined
            assertParamExists('adminAlbaoneControllerGetFeedPosts', 'feedUuid', feedUuid)
            const localVarPath = `/admin/albaone/feeds/{feedUuid}/posts`
                .replace(`{${"feedUuid"}}`, encodeURIComponent(String(feedUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (snsAccountUuid !== undefined) {
                localVarQueryParameter['snsAccountUuid'] = snsAccountUuid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 알바원 피드 목록 조회
         * @param {AdminAlbaoneControllerGetFeedsGenderEnum} [gender] 성별
         * @param {number} [age] 연령
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        adminAlbaoneControllerGetFeeds: async (gender?: AdminAlbaoneControllerGetFeedsGenderEnum, age?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/albaone/feeds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gender !== undefined) {
                localVarQueryParameter['gender'] = gender;
            }

            if (age !== undefined) {
                localVarQueryParameter['age'] = age;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 알바원 피드 유저 매치
         * @param {MatchFeedAndUserReqBodyDto} matchFeedAndUserReqBodyDto 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        adminAlbaoneControllerMatchFeedAndUser: async (matchFeedAndUserReqBodyDto: MatchFeedAndUserReqBodyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'matchFeedAndUserReqBodyDto' is not null or undefined
            assertParamExists('adminAlbaoneControllerMatchFeedAndUser', 'matchFeedAndUserReqBodyDto', matchFeedAndUserReqBodyDto)
            const localVarPath = `/admin/albaone/feeds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(matchFeedAndUserReqBodyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 알바원 피드 오류 해결
         * @param {MatchFeedAndUserReqBodyDto} matchFeedAndUserReqBodyDto 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        adminAlbaoneControllerResolveFeedError: async (matchFeedAndUserReqBodyDto: MatchFeedAndUserReqBodyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'matchFeedAndUserReqBodyDto' is not null or undefined
            assertParamExists('adminAlbaoneControllerResolveFeedError', 'matchFeedAndUserReqBodyDto', matchFeedAndUserReqBodyDto)
            const localVarPath = `/admin/albaone/feeds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(matchFeedAndUserReqBodyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 특정 알바원 피드의 게시물 목록 조회 API
         * @param {string} feedUuid 알바원 피드 uuid
         * @param {string} [snsAccountUuid] SNS 계정 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetFeedPostsAlbaone: async (feedUuid: string, snsAccountUuid?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'feedUuid' is not null or undefined
            assertParamExists('adminGetFeedPostsAlbaone', 'feedUuid', feedUuid)
            const localVarPath = `/v1/admin/albaone/feeds/{feedUuid}/posts`
                .replace(`{${"feedUuid"}}`, encodeURIComponent(String(feedUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (snsAccountUuid !== undefined) {
                localVarQueryParameter['snsAccountUuid'] = snsAccountUuid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 알바원 피드 목록 조회 API
         * @param {AdminGetFeedsAlbaoneGenderEnum} [gender] 성별
         * @param {number} [age] 연령
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetFeedsAlbaone: async (gender?: AdminGetFeedsAlbaoneGenderEnum, age?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/admin/albaone/feeds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gender !== undefined) {
                localVarQueryParameter['gender'] = gender;
            }

            if (age !== undefined) {
                localVarQueryParameter['age'] = age;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 알바원 피드 유저 매치 API
         * @param {MatchFeedAndUserReqBodyDto} matchFeedAndUserReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminMatchFeedAndUser: async (matchFeedAndUserReqBodyDto: MatchFeedAndUserReqBodyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'matchFeedAndUserReqBodyDto' is not null or undefined
            assertParamExists('adminMatchFeedAndUser', 'matchFeedAndUserReqBodyDto', matchFeedAndUserReqBodyDto)
            const localVarPath = `/v1/admin/albaone/feeds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(matchFeedAndUserReqBodyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 알바원 피드 오류 해결 API
         * @param {ResolveFeedAndUserRequestDto} resolveFeedAndUserRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminResolveFeedErrorAlbaone: async (resolveFeedAndUserRequestDto: ResolveFeedAndUserRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resolveFeedAndUserRequestDto' is not null or undefined
            assertParamExists('adminResolveFeedErrorAlbaone', 'resolveFeedAndUserRequestDto', resolveFeedAndUserRequestDto)
            const localVarPath = `/v1/admin/albaone/feeds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resolveFeedAndUserRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminAlbaoneApi - functional programming interface
 * @export
 */
export const AdminAlbaoneApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminAlbaoneApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 특정 알바원 피드의 게시물 목록 조회
         * @param {string} feedUuid 알바원 피드 uuid
         * @param {string} [snsAccountUuid] SNS 계정 uuid
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async adminAlbaoneControllerGetFeedPosts(feedUuid: string, snsAccountUuid?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminGetFeedPostsOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminAlbaoneControllerGetFeedPosts(feedUuid, snsAccountUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminAlbaoneApi.adminAlbaoneControllerGetFeedPosts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 알바원 피드 목록 조회
         * @param {AdminAlbaoneControllerGetFeedsGenderEnum} [gender] 성별
         * @param {number} [age] 연령
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async adminAlbaoneControllerGetFeeds(gender?: AdminAlbaoneControllerGetFeedsGenderEnum, age?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminGetFeedsOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminAlbaoneControllerGetFeeds(gender, age, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminAlbaoneApi.adminAlbaoneControllerGetFeeds']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 알바원 피드 유저 매치
         * @param {MatchFeedAndUserReqBodyDto} matchFeedAndUserReqBodyDto 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async adminAlbaoneControllerMatchFeedAndUser(matchFeedAndUserReqBodyDto: MatchFeedAndUserReqBodyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MatchFeedAndUserCreatedDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminAlbaoneControllerMatchFeedAndUser(matchFeedAndUserReqBodyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminAlbaoneApi.adminAlbaoneControllerMatchFeedAndUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 알바원 피드 오류 해결
         * @param {MatchFeedAndUserReqBodyDto} matchFeedAndUserReqBodyDto 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async adminAlbaoneControllerResolveFeedError(matchFeedAndUserReqBodyDto: MatchFeedAndUserReqBodyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResolveFeedErrorCreatedDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminAlbaoneControllerResolveFeedError(matchFeedAndUserReqBodyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminAlbaoneApi.adminAlbaoneControllerResolveFeedError']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 특정 알바원 피드의 게시물 목록 조회 API
         * @param {string} feedUuid 알바원 피드 uuid
         * @param {string} [snsAccountUuid] SNS 계정 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetFeedPostsAlbaone(feedUuid: string, snsAccountUuid?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminGetFeedPostsAlbaoneResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetFeedPostsAlbaone(feedUuid, snsAccountUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminAlbaoneApi.adminGetFeedPostsAlbaone']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 알바원 피드 목록 조회 API
         * @param {AdminGetFeedsAlbaoneGenderEnum} [gender] 성별
         * @param {number} [age] 연령
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetFeedsAlbaone(gender?: AdminGetFeedsAlbaoneGenderEnum, age?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminGetFeedsAlbaoneResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetFeedsAlbaone(gender, age, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminAlbaoneApi.adminGetFeedsAlbaone']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 알바원 피드 유저 매치 API
         * @param {MatchFeedAndUserReqBodyDto} matchFeedAndUserReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminMatchFeedAndUser(matchFeedAndUserReqBodyDto: MatchFeedAndUserReqBodyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminMatchFeedAndUserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminMatchFeedAndUser(matchFeedAndUserReqBodyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminAlbaoneApi.adminMatchFeedAndUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 알바원 피드 오류 해결 API
         * @param {ResolveFeedAndUserRequestDto} resolveFeedAndUserRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminResolveFeedErrorAlbaone(resolveFeedAndUserRequestDto: ResolveFeedAndUserRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminResolveFeedErrorAlbaoneResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminResolveFeedErrorAlbaone(resolveFeedAndUserRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminAlbaoneApi.adminResolveFeedErrorAlbaone']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminAlbaoneApi - factory interface
 * @export
 */
export const AdminAlbaoneApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminAlbaoneApiFp(configuration)
    return {
        /**
         * 
         * @summary 특정 알바원 피드의 게시물 목록 조회
         * @param {AdminAlbaoneApiAdminAlbaoneControllerGetFeedPostsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        adminAlbaoneControllerGetFeedPosts(requestParameters: AdminAlbaoneApiAdminAlbaoneControllerGetFeedPostsRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminGetFeedPostsOkDto> {
            return localVarFp.adminAlbaoneControllerGetFeedPosts(requestParameters.feedUuid, requestParameters.snsAccountUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 알바원 피드 목록 조회
         * @param {AdminAlbaoneApiAdminAlbaoneControllerGetFeedsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        adminAlbaoneControllerGetFeeds(requestParameters: AdminAlbaoneApiAdminAlbaoneControllerGetFeedsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AdminGetFeedsOkDto> {
            return localVarFp.adminAlbaoneControllerGetFeeds(requestParameters.gender, requestParameters.age, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 알바원 피드 유저 매치
         * @param {AdminAlbaoneApiAdminAlbaoneControllerMatchFeedAndUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        adminAlbaoneControllerMatchFeedAndUser(requestParameters: AdminAlbaoneApiAdminAlbaoneControllerMatchFeedAndUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<MatchFeedAndUserCreatedDto> {
            return localVarFp.adminAlbaoneControllerMatchFeedAndUser(requestParameters.matchFeedAndUserReqBodyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 알바원 피드 오류 해결
         * @param {AdminAlbaoneApiAdminAlbaoneControllerResolveFeedErrorRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        adminAlbaoneControllerResolveFeedError(requestParameters: AdminAlbaoneApiAdminAlbaoneControllerResolveFeedErrorRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResolveFeedErrorCreatedDto> {
            return localVarFp.adminAlbaoneControllerResolveFeedError(requestParameters.matchFeedAndUserReqBodyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 특정 알바원 피드의 게시물 목록 조회 API
         * @param {AdminAlbaoneApiAdminGetFeedPostsAlbaoneRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetFeedPostsAlbaone(requestParameters: AdminAlbaoneApiAdminGetFeedPostsAlbaoneRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminGetFeedPostsAlbaoneResponse> {
            return localVarFp.adminGetFeedPostsAlbaone(requestParameters.feedUuid, requestParameters.snsAccountUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 알바원 피드 목록 조회 API
         * @param {AdminAlbaoneApiAdminGetFeedsAlbaoneRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetFeedsAlbaone(requestParameters: AdminAlbaoneApiAdminGetFeedsAlbaoneRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AdminGetFeedsAlbaoneResponse> {
            return localVarFp.adminGetFeedsAlbaone(requestParameters.gender, requestParameters.age, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 알바원 피드 유저 매치 API
         * @param {AdminAlbaoneApiAdminMatchFeedAndUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminMatchFeedAndUser(requestParameters: AdminAlbaoneApiAdminMatchFeedAndUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminMatchFeedAndUserResponse> {
            return localVarFp.adminMatchFeedAndUser(requestParameters.matchFeedAndUserReqBodyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 알바원 피드 오류 해결 API
         * @param {AdminAlbaoneApiAdminResolveFeedErrorAlbaoneRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminResolveFeedErrorAlbaone(requestParameters: AdminAlbaoneApiAdminResolveFeedErrorAlbaoneRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminResolveFeedErrorAlbaoneResponse> {
            return localVarFp.adminResolveFeedErrorAlbaone(requestParameters.resolveFeedAndUserRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminAlbaoneControllerGetFeedPosts operation in AdminAlbaoneApi.
 * @export
 * @interface AdminAlbaoneApiAdminAlbaoneControllerGetFeedPostsRequest
 */
export interface AdminAlbaoneApiAdminAlbaoneControllerGetFeedPostsRequest {
    /**
     * 알바원 피드 uuid
     * @type {string}
     * @memberof AdminAlbaoneApiAdminAlbaoneControllerGetFeedPosts
     */
    readonly feedUuid: string

    /**
     * SNS 계정 uuid
     * @type {string}
     * @memberof AdminAlbaoneApiAdminAlbaoneControllerGetFeedPosts
     */
    readonly snsAccountUuid?: string
}

/**
 * Request parameters for adminAlbaoneControllerGetFeeds operation in AdminAlbaoneApi.
 * @export
 * @interface AdminAlbaoneApiAdminAlbaoneControllerGetFeedsRequest
 */
export interface AdminAlbaoneApiAdminAlbaoneControllerGetFeedsRequest {
    /**
     * 성별
     * @type {'male' | 'female'}
     * @memberof AdminAlbaoneApiAdminAlbaoneControllerGetFeeds
     */
    readonly gender?: AdminAlbaoneControllerGetFeedsGenderEnum

    /**
     * 연령
     * @type {number}
     * @memberof AdminAlbaoneApiAdminAlbaoneControllerGetFeeds
     */
    readonly age?: number
}

/**
 * Request parameters for adminAlbaoneControllerMatchFeedAndUser operation in AdminAlbaoneApi.
 * @export
 * @interface AdminAlbaoneApiAdminAlbaoneControllerMatchFeedAndUserRequest
 */
export interface AdminAlbaoneApiAdminAlbaoneControllerMatchFeedAndUserRequest {
    /**
     * 
     * @type {MatchFeedAndUserReqBodyDto}
     * @memberof AdminAlbaoneApiAdminAlbaoneControllerMatchFeedAndUser
     */
    readonly matchFeedAndUserReqBodyDto: MatchFeedAndUserReqBodyDto
}

/**
 * Request parameters for adminAlbaoneControllerResolveFeedError operation in AdminAlbaoneApi.
 * @export
 * @interface AdminAlbaoneApiAdminAlbaoneControllerResolveFeedErrorRequest
 */
export interface AdminAlbaoneApiAdminAlbaoneControllerResolveFeedErrorRequest {
    /**
     * 
     * @type {MatchFeedAndUserReqBodyDto}
     * @memberof AdminAlbaoneApiAdminAlbaoneControllerResolveFeedError
     */
    readonly matchFeedAndUserReqBodyDto: MatchFeedAndUserReqBodyDto
}

/**
 * Request parameters for adminGetFeedPostsAlbaone operation in AdminAlbaoneApi.
 * @export
 * @interface AdminAlbaoneApiAdminGetFeedPostsAlbaoneRequest
 */
export interface AdminAlbaoneApiAdminGetFeedPostsAlbaoneRequest {
    /**
     * 알바원 피드 uuid
     * @type {string}
     * @memberof AdminAlbaoneApiAdminGetFeedPostsAlbaone
     */
    readonly feedUuid: string

    /**
     * SNS 계정 uuid
     * @type {string}
     * @memberof AdminAlbaoneApiAdminGetFeedPostsAlbaone
     */
    readonly snsAccountUuid?: string
}

/**
 * Request parameters for adminGetFeedsAlbaone operation in AdminAlbaoneApi.
 * @export
 * @interface AdminAlbaoneApiAdminGetFeedsAlbaoneRequest
 */
export interface AdminAlbaoneApiAdminGetFeedsAlbaoneRequest {
    /**
     * 성별
     * @type {'male' | 'female'}
     * @memberof AdminAlbaoneApiAdminGetFeedsAlbaone
     */
    readonly gender?: AdminGetFeedsAlbaoneGenderEnum

    /**
     * 연령
     * @type {number}
     * @memberof AdminAlbaoneApiAdminGetFeedsAlbaone
     */
    readonly age?: number
}

/**
 * Request parameters for adminMatchFeedAndUser operation in AdminAlbaoneApi.
 * @export
 * @interface AdminAlbaoneApiAdminMatchFeedAndUserRequest
 */
export interface AdminAlbaoneApiAdminMatchFeedAndUserRequest {
    /**
     * 
     * @type {MatchFeedAndUserReqBodyDto}
     * @memberof AdminAlbaoneApiAdminMatchFeedAndUser
     */
    readonly matchFeedAndUserReqBodyDto: MatchFeedAndUserReqBodyDto
}

/**
 * Request parameters for adminResolveFeedErrorAlbaone operation in AdminAlbaoneApi.
 * @export
 * @interface AdminAlbaoneApiAdminResolveFeedErrorAlbaoneRequest
 */
export interface AdminAlbaoneApiAdminResolveFeedErrorAlbaoneRequest {
    /**
     * 
     * @type {ResolveFeedAndUserRequestDto}
     * @memberof AdminAlbaoneApiAdminResolveFeedErrorAlbaone
     */
    readonly resolveFeedAndUserRequestDto: ResolveFeedAndUserRequestDto
}

/**
 * AdminAlbaoneApi - object-oriented interface
 * @export
 * @class AdminAlbaoneApi
 * @extends {BaseAPI}
 */
export class AdminAlbaoneApi extends BaseAPI {
    /**
     * 
     * @summary 특정 알바원 피드의 게시물 목록 조회
     * @param {AdminAlbaoneApiAdminAlbaoneControllerGetFeedPostsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AdminAlbaoneApi
     */
    public adminAlbaoneControllerGetFeedPosts(requestParameters: AdminAlbaoneApiAdminAlbaoneControllerGetFeedPostsRequest, options?: RawAxiosRequestConfig) {
        return AdminAlbaoneApiFp(this.configuration).adminAlbaoneControllerGetFeedPosts(requestParameters.feedUuid, requestParameters.snsAccountUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 알바원 피드 목록 조회
     * @param {AdminAlbaoneApiAdminAlbaoneControllerGetFeedsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AdminAlbaoneApi
     */
    public adminAlbaoneControllerGetFeeds(requestParameters: AdminAlbaoneApiAdminAlbaoneControllerGetFeedsRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminAlbaoneApiFp(this.configuration).adminAlbaoneControllerGetFeeds(requestParameters.gender, requestParameters.age, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 알바원 피드 유저 매치
     * @param {AdminAlbaoneApiAdminAlbaoneControllerMatchFeedAndUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AdminAlbaoneApi
     */
    public adminAlbaoneControllerMatchFeedAndUser(requestParameters: AdminAlbaoneApiAdminAlbaoneControllerMatchFeedAndUserRequest, options?: RawAxiosRequestConfig) {
        return AdminAlbaoneApiFp(this.configuration).adminAlbaoneControllerMatchFeedAndUser(requestParameters.matchFeedAndUserReqBodyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 알바원 피드 오류 해결
     * @param {AdminAlbaoneApiAdminAlbaoneControllerResolveFeedErrorRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AdminAlbaoneApi
     */
    public adminAlbaoneControllerResolveFeedError(requestParameters: AdminAlbaoneApiAdminAlbaoneControllerResolveFeedErrorRequest, options?: RawAxiosRequestConfig) {
        return AdminAlbaoneApiFp(this.configuration).adminAlbaoneControllerResolveFeedError(requestParameters.matchFeedAndUserReqBodyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 특정 알바원 피드의 게시물 목록 조회 API
     * @param {AdminAlbaoneApiAdminGetFeedPostsAlbaoneRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAlbaoneApi
     */
    public adminGetFeedPostsAlbaone(requestParameters: AdminAlbaoneApiAdminGetFeedPostsAlbaoneRequest, options?: RawAxiosRequestConfig) {
        return AdminAlbaoneApiFp(this.configuration).adminGetFeedPostsAlbaone(requestParameters.feedUuid, requestParameters.snsAccountUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 알바원 피드 목록 조회 API
     * @param {AdminAlbaoneApiAdminGetFeedsAlbaoneRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAlbaoneApi
     */
    public adminGetFeedsAlbaone(requestParameters: AdminAlbaoneApiAdminGetFeedsAlbaoneRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminAlbaoneApiFp(this.configuration).adminGetFeedsAlbaone(requestParameters.gender, requestParameters.age, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 알바원 피드 유저 매치 API
     * @param {AdminAlbaoneApiAdminMatchFeedAndUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAlbaoneApi
     */
    public adminMatchFeedAndUser(requestParameters: AdminAlbaoneApiAdminMatchFeedAndUserRequest, options?: RawAxiosRequestConfig) {
        return AdminAlbaoneApiFp(this.configuration).adminMatchFeedAndUser(requestParameters.matchFeedAndUserReqBodyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 알바원 피드 오류 해결 API
     * @param {AdminAlbaoneApiAdminResolveFeedErrorAlbaoneRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAlbaoneApi
     */
    public adminResolveFeedErrorAlbaone(requestParameters: AdminAlbaoneApiAdminResolveFeedErrorAlbaoneRequest, options?: RawAxiosRequestConfig) {
        return AdminAlbaoneApiFp(this.configuration).adminResolveFeedErrorAlbaone(requestParameters.resolveFeedAndUserRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const AdminAlbaoneControllerGetFeedsGenderEnum = {
    Male: 'male',
    Female: 'female'
} as const;
export type AdminAlbaoneControllerGetFeedsGenderEnum = typeof AdminAlbaoneControllerGetFeedsGenderEnum[keyof typeof AdminAlbaoneControllerGetFeedsGenderEnum];
/**
 * @export
 */
export const AdminGetFeedsAlbaoneGenderEnum = {
    Male: 'male',
    Female: 'female'
} as const;
export type AdminGetFeedsAlbaoneGenderEnum = typeof AdminGetFeedsAlbaoneGenderEnum[keyof typeof AdminGetFeedsAlbaoneGenderEnum];
